<template>
  <el-dialog
    title="理论中心组学习审核"
    :visible.sync="reviewDialog.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="closeDialog"
  >
    <el-form
      :model="examineForm"
      :rules="rules"
      ref="examineForm"
      label-width="100px"
    >
      <el-form-item label="审核结果：" prop="auditSchedule">
        <el-radio-group
          v-model="examineForm.auditSchedule"
          @change="examineResultEvent"
        >
          <el-radio :label="2">不同意</el-radio>
          <el-radio :label="1">同意</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="驳回原因："
        v-if="examineForm.auditSchedule === 2"
        prop="auditContent"
      >
        <el-input
          type="textarea"
          placeholder="请输入驳回原因"
          v-model="examineForm.auditContent"
          maxlength="200"
          @input="reasonInputEvent"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="短信通知：" prop="isNotice">
        <el-radio-group v-model="examineForm.isNotice" @change="msgNoticeEvent">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="消息内容：" prop="msg" v-if="examineForm.isNotice && examineForm.auditSchedule == 1">
        <el-input type="textarea" value="您好，您有新的理论中心组学习申报待审核，请及时审核。" disabled></el-input>
      </el-form-item>
      <el-form-item label="发送对象：" v-if="examineForm.isNotice && examineForm.auditSchedule == 1">
        所有下个节点审核人
      </el-form-item>
      <el-form-item label="消息内容：" prop="msg" v-if="examineForm.isNotice">
        <el-input type="textarea" v-model="msg" disabled></el-input>
      </el-form-item>
      <el-form-item label="发送对象：" v-if="examineForm.isNotice">
        所有提交人
      </el-form-item>
    </el-form>
    <!-- <div class="sendobj-content" v-if="examineForm.isNotice">
      <div class="lable">发送对象：</div>
      <div class="text">
        <div
          :style="{ 'max-height': textOpenFlag ? textHeight : '' }"
          :class="{ unfoldText: textOpenFlag }"
          ref="desc"
        >
          {{ sendObj }}
        </div>
        <el-link
          :underline="false"
          v-if="showBtnFlag"
          @click="textOpenFlag = !textOpenFlag"
          class="btn"
          type="primary"
          >{{ textOpenFlag ? "展开" : "收起" }}</el-link
        >
      </div>
    </div> -->
    <div class="submit-content">
      <div class="bor"></div>
      <div class="btn">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button type="primary" size="small" @click="submitForm"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { learnBatchAudit } from "@/api/studyService";

export default {
  props: {
    reviewDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
          selectList: [],
        };
      },
    },
  },
  data() {
    return {
      msg: "您好，您提交的理论中心组学习申报有学员审核未通过，原因：{驳回原因}",
      textOpenFlag: false,
      textHeight: null,
      showBtnFlag: false,
      sendObj: "", // 名字
      examineForm: {
        auditSchedule: 2,
        noticeType: 0,
        auditContent: "",
        isNotice: true,
        uuids: "",
      },
      rules: {
        auditSchedule: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
        sendObj: [
          { required: true, message: "请选择发送对象", trigger: "change" },
        ],
        isNotice: [
          { required: true, message: "请选择短信通知", trigger: "change" },
        ],
        auditContent: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.sendObj = this.sendUsers(this.reviewDialog.selectList);
    // if (this.reviewDialog.flag) {
    //   this.$nextTick(() => {
    //     this.calculateText();
    //   });
    // }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    // 发送人去重
    sendUsers(list) {
      if (list && list.length > 0) {
        let selectList = [...list];
        // 处理选中的数组，组装数据
        // 去重获取createUserName(selectList为根据，操作人电话去重数组)
        // 以操作人id为key。操作人所对应调动条数为value
        const peon = {};
        selectList = selectList.reduce((acc, next) => {
          if (peon[next.createUserId]) {
            peon[next.createUserId] += 1;
          } else {
            if ((peon[next.createUserId] = 1)) {
              acc.push(next);
            }
          }
          return acc;
        }, []);
        // 操作人names
        let sendObj = selectList.map((o) => o.createUserName).join("、");
        return sendObj;
      }
    },
    // 批量审核确认提交
    submitForm() {
      this.$refs.examineForm.validate(async (valid) => {
        if (valid) {
          let params = { ...this.examineForm };
          params.uuids = this.reviewDialog.selectList.map((v) => {
            return v.uuid;
          });
          if (params.auditSchedule == 1) {
            params.auditContent = "";
          }
          console.log(params);
          let { msg, code } = await learnBatchAudit(params);
          if (code == 0) {
            this.$message.success(msg);
            this.$emit("closeDialog", true);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    calculateText() {
      let twoHeight = 24 * 1.7; // 固定内容的高度
      this.textHeight = `${twoHeight}px`;
      this.curHeight = this.$refs.desc.offsetHeight; // 获取内容元素的高度
      if (this.curHeight > twoHeight) {
        this.textOpenFlag = true;
        this.showBtnFlag = true;
      } else {
        this.textOpenFlag = false;
        this.showBtnFlag = false;
      }
    },
    // 驳回原因输入框触发事件
    reasonInputEvent(val) {
      this.msg =
        "您好，您提交的理论中心组学习申报有学员审核未通过，原因：" +
        (val.length > 0 ? val : "{驳回原因}");
    },
    // 审核结果按钮
    examineResultEvent(val) {
      console.log(val);
      this.examineResultLable = val;
      if (val == 1) {
        this.examineForm.isNotice = false;
      } else {
        this.examineForm.isNotice = true;
        this.msg =
          "您好，您提交的理论中心组学习申报有学员审核未通过，原因：" +
          (this.examineForm.auditContent.length > 0
            ? this.examineForm.auditContent
            : "{驳回原因}");
      }
    },
    // 审核结果按钮
    msgNoticeEvent(val) {
      console.log(val);
      this.msgNoticeLable = val;
      if (val == 1 && this.examineResultLable == 1) {
        this.msg = "您好，您提交的理论中心组学习申报有学员已审核通过。";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
}
.sendobj-content {
  display: flex;
  font-size: 12px;
  color: #51627d;
  .lable {
    width: 78px;
    margin-left: 29px;
    position: relative;
    &::after {
      z-index: 3;
      content: "*";
      position: absolute;
      top: 1px;
      left: -10px;
      color: red;
    }
  }
}
.text {
  position: relative;
  flex: 1;
  .btn {
    font-size: 14px;
    right: -18px;
    position: absolute;
    height: 28px;
    bottom: -28px;
    background-color: #fff;
    padding-left: 60px;
    padding-right: 10px;
  }
}
.unfoldText {
  overflow: hidden;
  display: block;
  &::after {
    z-index: 3;
    content: "......";
    position: absolute;
    bottom: 0px;
    right: 8px;
    width: 0px;
    padding-left: 25px;
  }
}
</style>
